const CLIPBOARD_IMAGE_EXTENSIONS: Record<string, string> = {
  "image/gif": "gif",
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/webp": "webp",
};

function clipboardImageName(file: File, index: number, now: Date) {
  if (file.name.trim()) return file.name;
  const extension = CLIPBOARD_IMAGE_EXTENSIONS[file.type.toLowerCase()] ?? "png";
  const timestamp = now.toISOString().replace(/[:.]/g, "-");
  return `粘贴图片-${timestamp}-${index + 1}.${extension}`;
}

/**
 * 只读取剪贴板里的图片 File。普通文本粘贴返回空数组，调用方不得阻止浏览器默认行为。
 * DataTransfer.items 是优先来源；部分浏览器只实现 files，因此保留无重复的降级分支。
 */
export function clipboardImageFiles(
  clipboardData: Pick<DataTransfer, "items" | "files">,
  now = new Date(),
) {
  const images: File[] = [];
  const seen = new Set<File>();

  for (const item of Array.from(clipboardData.items ?? [])) {
    if (item.kind !== "file" || !item.type.toLowerCase().startsWith("image/")) continue;
    const file = item.getAsFile();
    if (!file || seen.has(file)) continue;
    images.push(file);
    seen.add(file);
  }

  for (const file of Array.from(clipboardData.files ?? [])) {
    if (!file.type.toLowerCase().startsWith("image/") || seen.has(file)) continue;
    images.push(file);
    seen.add(file);
  }

  return images.map((file, index) => {
    const name = clipboardImageName(file, index, now);
    return name === file.name
      ? file
      : new File([file], name, { type: file.type, lastModified: file.lastModified });
  });
}

/** 返回 true 才表示图片已进入附件状态机，调用方此时才能 preventDefault。 */
export function stageClipboardImages(
  clipboardData: Pick<DataTransfer, "items" | "files">,
  stage: (files: File[]) => boolean,
) {
  const images = clipboardImageFiles(clipboardData);
  return images.length > 0 && stage(images);
}
